export default "__VITE_ASSET__12889d5e__"